import { Component, OnInit, Output, EventEmitter, Input, TemplateRef, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { ContactsVm, FilteredContactVm } from 'src/app/viewModels/core/contacts-vm';

import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { DataSharingService } from '../resuableServices/data-sharing.service';
import { CompanysVm, FilteredCompanyVm } from 'src/app/viewModels/core/company-vm';
import { ContactsService } from 'src/app/applicationModules/contact/services/coreService/contacts.service';
import { ConfirmDialogModel, ConfirmDialogComponent} from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { ModuleName } from '../Enum/common.enum';


export interface State {
  name: string;
  email: string;
  role: string;
  pic: string,
}

@Component({
  selector: 'app-associate-contact',
  templateUrl: './associate-contact.component.html',
  styleUrls: ['./associate-contact.component.scss']
})
export class AssociateContactComponent implements OnInit {
@Output() showContactDetail = new EventEmitter<boolean>();
@Input() datalist:any=[]; 
@Input() contactID:number; 
showdetail:boolean = true;
addnewContact:boolean = false;
showAddContact:boolean = false;
addnewSharedContact:boolean = false;
Module:string;
filteredroles: Observable<string[]>;
value = '';
Owners:any=[];
NormalContacts: any=[];
NormalCompanys :any=[];
NormalCore :any=[];
SharedContacts: any=[];
SharedRoleList : any=[];
stateCtrlValue: string="";

currentUser: any;
databaseId: string;
organizationId: string;
responseHolder: any;
contactsList: any=[];
companysList: any=[];
isShare:boolean=false;
showAddButton = false;
showCompanyRoleAddButton = false;
showContactRoleAddButton = false;
searchName:string='';
roleCtrl = new FormControl();
allTransRoles: any = [{name:'Buyer'},{name:'Seller'},{name:'Agent'}];
  selectedRoles: any=[];
  @ViewChild('roleInput') roleInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  selectable = true;
  removable = true;
  isRolePopup: boolean=false;
  Roles: any=[];
  RolesCompany: any=[];
  transRoleList: any=[];
  currentRoleContact: any;
  currentRoleCompany: any;
  showDetail: boolean = false;
  TransactionId:number;
  peoples :any=[];
  selectedcompanyList :any=[];
  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  mainModuleName:string="";
  selectedsharedAccessRole : any=[];
  isSharedAccessRolePopup:boolean=false;
  sharedAccessRoleList: any=[];
  SelectedModuleName:any=[]=[];
  CompanyName:string="";
  CoreName:string="";
  OfficeIDList: any=[];
  myOfficeID: any;
  mainModuleNameSenForAdd:string="";
  clickEventsubscriptionPreviousNextD:any;
  clickEventsubscriptionListRefreshConact:any;
constructor(private statusConst: StatusConstant, private loaderService: LoaderService,
  private contactsService: ContactsService, private toastr: ToastrService,private filteredContactVm:FilteredContactVm,
  private filteredCompanyVm:FilteredCompanyVm,
  private contactsVm: ContactsVm,private companysVm: CompanysVm,
   private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
  private dialog: MatDialog, private cdr: ChangeDetectorRef, private _dataSharingService: DataSharingService) {

  const encryptedtoken = sessionStorage.getItem('userToken');
  this.databaseId = sessionStorage.getItem('databaseId');
  this.organizationId = sessionStorage.getItem('organizationID');
  const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
  this.currentUser = jwt_decode(token);

  this.filteredroles = this.roleCtrl.valueChanges.pipe(
    startWith(null),
    map((fruit: string | null) => fruit ? this._filter(fruit) : this.allTransRoles.slice()));

  this.filteredStates = this.stateCtrl.valueChanges.pipe(
    startWith(''),
    map(state => state ? this._filterStates(state) : this.states.slice())
  );

var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)	
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
}

ngAfterContentChecked(){
  this.cdr.detectChanges();
}

ngOnDestroy() {
  this.clickEventsubscriptionPreviousNextD.unsubscribe();
  //this.clickEventsubscriptionListRefreshConact.unsubscribe();
}

ngOnInit(): void {
  var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
  this.SelectedModuleName = menuModulesList.filter(x => x.mainModuleName == ModuleName.Contact);
  if(this.SelectedModuleName.length>0){
    this.mainModuleName = this.SelectedModuleName[0].orgModuleName;
  }
  
  var CompName=[];
  CompName = menuModulesList.filter(x => x.mainModuleName == ModuleName.Company);
  if(CompName.length>0){
    this.CompanyName = CompName[0].orgModuleName;
  }
  
  var CoreName=[];
  CoreName = menuModulesList.filter(x => x.mainModuleName == ModuleName.Core);
  if(CoreName.length>0){
    this.CoreName = CoreName[0].orgModuleName;
  }
  
  var mainModuleNameSenForAdd= menuModulesList.filter(x => x.orgModuleName == this.mainModuleName);
  this.mainModuleNameSenForAdd = mainModuleNameSenForAdd[0].mainModuleName;

  this.clickEventsubscriptionPreviousNextD = this._dataSharingService.getNextPreviousForRightPanelFromContact().subscribe((result) => {
    if (result) {
      this.showAddButton=false;
      this.showCompanyRoleAddButton=false;
      this.showContactRoleAddButton=false;
      this.Owners=[];
      this.NormalCompanys=[];
      this.NormalContacts=[];
      this.SharedContacts=[];
      this.getNormalAndSharedContacts();
      this.getNormalAndSharedCompanys();
      this.getNormalAndSharedCores();
      }
    });

   this.clickEventsubscriptionListRefreshConact = this._dataSharingService.getRefreshListFromCore().subscribe((result) => {
      if (result) {       
        this.getNormalAndSharedContacts();
        this.getNormalAndSharedCompanys();
        this.getNormalAndSharedCores();
      }
   });

  this.showAddButton=false;
  this.showCompanyRoleAddButton=false;
  this.showContactRoleAddButton=false;
  this.Owners=[];
  this.NormalCompanys=[];
  this.NormalContacts=[];
  this.SharedContacts=[];
  this.getNormalAndSharedContacts();
  this.getNormalAndSharedCompanys();
  this.getNormalAndSharedCores();
}

getCloseDetail(message) {
  this.showDetail = message;
}

addNew(module){
  this.Module = module;
  this.showAddContact = !this.showAddContact;
}

getClose(message){
  this.showAddContact = message;
}

addContact(){
  this.addnewContact = !this.addnewContact;
}

addSharedContact(){
  this.addnewSharedContact = !this.addnewSharedContact;
}

private _filterStates(value: string): State[] {
  const filterValue = value.toLowerCase();
  return this.states.filter(state => state.name.toLowerCase().indexOf(filterValue) === 0);
}

remove(fruit: string): void {
  const index = this.selectedRoles.indexOf(fruit);
  if (index >= 0) {
    this.selectedRoles.splice(index, 1);
  }
}

add(event: MatChipInputEvent): void {
  const input = event.input;
  const value = event.value.toLowerCase();
  
  if ((value || '').trim()) {
    var arrToUp = String.prototype.toLowerCase.apply(this.selectedRoles).split(",");
    const index = arrToUp.indexOf(value.trim());

    if (index >= 0) {
      //this.fruits.splice(index, 1);
    }
    else {
      this.selectedRoles.push(event.value.trim());
    }
  }
  // Reset the input value
  if (input) {
    input.value = '';
  }
  this.roleCtrl.setValue(null);
}

selected(event: MatAutocompleteSelectedEvent): void {
  const index = this.selectedRoles.indexOf(event.option.viewValue);
  if (index >= 0) {
    this.roleInput.nativeElement.value = '';   
  }
  else {
    this.selectedRoles.push(event.option.viewValue);
    this.roleInput.nativeElement.value = '';
    this.roleCtrl.setValue(null);
  }
}

private _filter(value: string): string[] {
  const filterValue = value.toLowerCase();
  return this.allTransRoles.filter(fruit => fruit.name.toLowerCase().indexOf(filterValue) === 0);
}

getCloseDetails(message){
  this.showDetail = false;
}

contactDetail(detail){
  if(detail.userID>0){
    return;
  }
  this.Module= "Contact"; //this.mainModuleName;
  this.TransactionId = detail.associatedContactID;  
  this.showDetail = !this.showDetail;
}

companyDetail(detail){
  this.Module="Company"; //this.CompanyName;
  this.TransactionId = detail.companyID;  
  this.showDetail = !this.showDetail;
}

coreDetail(detail){
  this.Module = "Core"; //this.CoreName;
  this.TransactionId = detail.coreID;  
  this.showDetail = !this.showDetail;
}


getNormalAndSharedContacts() {
  this.contactsVm.DatabaseID = Number(this.databaseId);
  this.contactsVm.OrganizationID = Number(this.organizationId);
  this.contactsVm.UserID = this.currentUser.UID;
  this.contactsVm.ContactID = Number(sessionStorage.getItem("transactionID"));
  this.loaderService.show();
  this.contactsService.getNormalAndSharedContactContacts(this.contactsVm).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.Owners = response.data.owners;
        this.NormalContacts = response.data.contactListModel;
        this.SharedContacts = response.data.sharedContactListModel;
        this.SharedRoleList = response.data.sharedRoleListModel;
        if(this.Owners!=null){
        this.Owners.forEach(e => {
          e.name= this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.name) +' '+this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.lastName);
          e.email= this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.email);
          e.shortName = e.name.match(/\b(\w)/g).join('');
        });
        }
        if(this.Owners==null){
          this.Owners=[];
        }
        this.NormalContacts.forEach(e => {
          e.shortName = e.name.match(/\b(\w)/g).join('');
        });      
        this.SharedRoleList.forEach(e => {
          e.shortName=e.name.match(/\b(\w)/g).join('');
        });
        if(this.SharedContacts!=null){
          this.SharedContacts.forEach(e => {
            if(e.userID>0){
              e.name= this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.name) +' '+this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.lastName);
              e.email= this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.email);
              e.shortName=e.name.match(/\b(\w)/g).join('');
            }else{
              e.shortName=e.name.match(/\b(\w)/g).join('');
            }
            if(e.contactContactRoleMappingModel==null){
              e.contactContactRoleMappingModel=[];
            }       
          });
        } 
        this.loaderService.hide();
      }
    }
    else{
      this.loaderService.hide();
    }
  });
}

getNormalAndSharedCompanys() {
  this.companysVm.DatabaseID = Number(this.databaseId);
  this.companysVm.OrganizationID = Number(this.organizationId);
  this.companysVm.UserID = this.currentUser.UID;
  this.companysVm.ContactID=Number(sessionStorage.getItem("transactionID"));
  this.loaderService.show();
  this.contactsService.getNormalAndSharedContactCompanys(this.companysVm).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.NormalCompanys = response.data.companyListModel;        
        this.NormalCompanys.forEach(e => {
          e.shortName=e.name.match(/\b(\w)/g).join('');
        });       
        this.loaderService.hide();
      }
    }
    else{
      this.loaderService.hide();
    }
  });
}

getNormalAndSharedCores() {
  this.companysVm.DatabaseID = Number(this.databaseId);
  this.companysVm.OrganizationID = Number(this.organizationId);
  //this.companysVm.UserID = this.currentUser.UID;
  this.companysVm.ContactID=Number(sessionStorage.getItem("transactionID"));
  this.loaderService.show();
  this.contactsService.getNormalAndSharedContactCores(this.companysVm).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.NormalCore = response.data.getContactCoreListModel;        
        this.NormalCore.forEach(e => {
          e.shortName=e.name.match(/\b(\w)/g).join('');
        });       
        this.loaderService.hide();
      }
    }
    else{
      this.loaderService.hide();
    }
  });
}


getContactListCoreImplementation(searchValue:any) {
 this.filteredContactVm.DatabaseID = Number(this.databaseId);
 this.filteredContactVm.OrganizationID = Number(this.organizationId);
 this.filteredContactVm.UserID = this.currentUser.UID;
 this.filteredContactVm.searchValue=searchValue;
 this.searchName = searchValue;
 this.filteredContactVm.ContactID = Number(sessionStorage.getItem("transactionID"));
 this.contactID = Number(sessionStorage.getItem("transactionID"));
 this.filteredContactVm.PageSize=0;
 this.contactsService.GetContactListCoreImplementation(this.filteredContactVm).subscribe(response => {
   if (response != undefined) {
     this.responseHolder = response;
     if (this.responseHolder.status == this.statusConst.statusSuccess) {
       this.contactsList = response.data.contactListModel;
       this.contactsList.forEach(e => {
        e.shortName=e.name.match(/\b(\w)/g).join('');
      });
      this.contactsList.push(
        {
          "contactID":0,
          "associatedContactID":0,
          "name":"Create New",
          "email":"",
          "imageUrl":"",
          "isShared":this.isShare,
          "contactContactUserMapID":0,
          "trasactionalRoleIds":[],
          "contactContactRoleMappingModels":[],
          "shortName":"CN"
        }
      )    
     }
   }
 });
}

getCompanyListCoreImplementation(searchValue:any) {
  this.filteredCompanyVm.DatabaseID = Number(this.databaseId);
  this.filteredCompanyVm.OrganizationID = Number(this.organizationId);
  this.filteredCompanyVm.UserID = this.currentUser.UID;
  this.filteredCompanyVm.searchValue=searchValue;
  this.searchName =searchValue;
  this.filteredCompanyVm.ContactID=Number(sessionStorage.getItem("transactionID"));
  this.contactID=Number(sessionStorage.getItem("transactionID"));
  this.filteredCompanyVm.PageSize=0;
  this.contactsService.GetCompanyListCoreImplementation(this.filteredCompanyVm).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.companysList = response.data.companyListModel;
        this.companysList.forEach(e => {
         e.shortName=e.name.match(/\b(\w)/g).join('');
       });
       this.companysList.push(
         {
           "companyID":0,
           "contactID":0,
           "name":"Create New",
           "email":"",
           "imageUrl":"",
           "isShared":this.isShare,
           "coreCompanyUserMapID":0,
           "trasactionalRoleIds":[],
           "companyCoreRoleMappingModels":[],
           "shortName":"CN"
         }
       )    
      }
    }
  });
}

getTransactinalRoles(searchValue:any) {
 this.filteredContactVm.DatabaseID = Number(this.databaseId);
 this.filteredContactVm.OrganizationID = Number(this.organizationId);
 this.filteredContactVm.UserID = this.currentUser.UID;
 this.filteredContactVm.searchValue=searchValue;
 this.filteredContactVm.PageSize=0;
 this.filteredContactVm.officeID=this.myOfficeID;
 this.filteredContactVm.officeIDList=this.OfficeIDList; 
 this.contactsService.getTransactinalRoles(this.filteredContactVm).subscribe(response => {
   if (response != undefined) {
     this.responseHolder = response;
     if (this.responseHolder.status == this.statusConst.statusSuccess) {
       this.transRoleList = response.data.transactionalRolesModels;
       this.transRoleList=this.transRoleList.filter(m=>!this.currentRoleContact.trasactionalRoleIds.includes(m.transctionalRoleID));
      if(this.transRoleList.length==0)
          this.transRoleList.push(
           {
             "transctionalRoleID":0,
             "contactID":0,
             "transactionalRoleName":searchValue,
           }
         )    
     }
   }
 });
}

deleteSelectedContact(contactID:any,associatedContactID:any,contactContactUserMapID:any){
  const message = `Are you sure you want to delete this Record?`;
  const title = `Confirm Delete`;
  const confirm = `Delete`;
  const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if(dialogResult){
        this.contactsVm.DatabaseID = Number(this.databaseId);
        this.contactsVm.OrganizationID = Number(this.organizationId);
        this.contactsVm.UserID = this.currentUser.UID;  
        this.contactsVm.ContactContactUserMapID = Number(contactContactUserMapID);
        this.contactsVm.ContactID = Number(sessionStorage.getItem("transactionID"));
        this.contactsVm.associatedContactID = Number(associatedContactID);
        this.contactsVm.ContactContactRoleID=0;
        this.loaderService.show();
        this.contactsService.deleteSelectedContactContact(this.contactsVm).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.Owners =response.data.owners;
              this.NormalContacts = response.data.contactListModel;
              this.SharedContacts= response.data.sharedContactListModel;
              this.SharedRoleList = response.data.sharedRoleListModel;
              if(this.Owners!=null){
              this.Owners.forEach(e => {
                e.name= this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.name) +' '+this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.lastName);
                e.email= this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.email);
                e.shortName=e.name.match(/\b(\w)/g).join('');
              });
             }
              if(this.Owners==null){
                this.Owners=[];
              }
              this.NormalContacts.forEach(e => {
                e.shortName=e.name.match(/\b(\w)/g).join('');
              });
              if(this.SharedContacts!=null){
                this.SharedContacts.forEach(e => {
                  if(e.userID>0){
                    e.name= this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.name) +' '+this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.lastName);
                    e.email= this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.email);
                    e.shortName=e.name.match(/\b(\w)/g).join('');
                  }else{
                    e.shortName=e.name.match(/\b(\w)/g).join('');
                  }
                  if(e.contactContactRoleMappingModel==null){
                    e.contactContactRoleMappingModel=[];
                  }       
                });
              } 
              this.SharedRoleList.forEach(e => {
                e.shortName=e.name.match(/\b(\w)/g).join('');
              });
              this.toastr.success('Record Deleted successfully.', '', {
                timeOut: 1000,
              });
              this.loaderService.hide();
            }
          }
        });
      }

    });
  
}

deleteSelectedCompany(contactID:any,CompanyID:any,contactCompanyUserMapID:any){
  const message = `Are you sure you want to delete this Record?`;
  const title = `Confirm Delete`;
  const confirm = `Delete`;
  const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if(dialogResult){
        this.companysVm.DatabaseID = Number(this.databaseId);
        this.companysVm.OrganizationID = Number(this.organizationId);
        this.companysVm.UserID = this.currentUser.UID;
        this.companysVm.ContactID=Number(sessionStorage.getItem("transactionID"));
        this.companysVm.ContactCompanyUserMapID = Number(contactCompanyUserMapID);
        this.companysVm.CompanyID = Number(CompanyID);
        this.companysVm.ContactCompanyRoleID = 0;
        this.loaderService.show();
        this.contactsService.deleteContactSelectedCompany(this.companysVm).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.NormalCompanys = response.data.companyListModel;  
              if(this.NormalCompanys!=null){
                this.NormalCompanys.forEach(e => {
                  e.shortName=e.name.match(/\b(\w)/g).join('');
                });
              } 
              this.toastr.success('Record Deleted successfully.', '', {
                timeOut: 1000,
              });     
              this.loaderService.hide();
            }
          }
        });

      }
    });
  
}


contactSelected(contactSelected:any){
  if(contactSelected.contactID == 0) { 
  this.dialog.closeAll();
  this.addNew( this.SelectedModuleName[0].orgModuleName);
  // this.addNew('Contact');
  return ;
 }

 let contact= this.peoples.find(m=>m.associatedContactID == contactSelected.contactID);
 
 if(contact == undefined || contact=='' || contact == null){ 
  this.peoples.push({
    name : contactSelected.name,
    email: contactSelected.email,
    img: contactSelected.imageUrl, 
    associatedContactID:contactSelected.contactID,
    isShared:this.isShare,
    isOwner:false,
    shortName:contactSelected.shortName,
    ContactID:Number(sessionStorage.getItem("transactionID")), 
  });
  if(this.peoples.length > 0){
    this.showAddButton=true;
  }
  else{
    this.showAddButton=false;
  }
 
 } 
}


companySelected(companySelected:any){
  if(companySelected.companyID == 0) { 
  this.dialog.closeAll();
  this.addNew(this.CompanyName);
  //this.addNew('Company');
  return ;
 }
 let company= this.selectedcompanyList.find(m=>m.companyID == companySelected.companyID);
 
 if(company == undefined || company=='' || company == null){ 
  this.selectedcompanyList.push({
    name : companySelected.name,
    email: companySelected.email,
    img: companySelected.imageUrl, 
    companyID:companySelected.companyID,
    isShared:this.isShare,
    shortName:companySelected.shortName,
    ContactID:Number(sessionStorage.getItem("transactionID"))
  });
  if(this.selectedcompanyList.length > 0){
    this.showAddButton=true;
  }
  else{
    this.showAddButton=false;
  } 
 } 
}

RoleSelected(roleSelected:any){
  let role= this.Roles.find(m=>m.transctionalRoleID == roleSelected.transctionalRoleID);  
  if(roleSelected.transctionalRoleID==0) { 
  if(this.currentRoleContact.contactContactRoleMappingModel.find(m=>m.rloeName.toLowerCase()==roleSelected.transactionalRoleName.toLowerCase())!=undefined) {
    this.toastr.warning('Role already selected.', '', {
      timeOut: 1000,
    });
    return;
  }
    let newRole = this.Roles.find(m=>m.transactionalRoleName.toLowerCase() == roleSelected.transactionalRoleName.toLowerCase());
    if(newRole == undefined) { 
     this.Roles.push({
        transactionalRoleName : roleSelected.transactionalRoleName, 
        transctionalRoleID:roleSelected.transctionalRoleID,
        contactID:Number(sessionStorage.getItem("transactionID")),
        associatedContactID:Number(this.currentRoleContact.associatedContactID),
        //userID :Number(this.currentRoleContact.userID),
      });
      if(this.Roles.length > 0){
        this.showContactRoleAddButton=true;
      }
      if(this.Roles.length == 0){
        this.showContactRoleAddButton=false;
      }
    }
    return;
  }
  
  if(role == undefined || role == '' || role == null) { 
   this.Roles.push({
     transactionalRoleName : roleSelected.transactionalRoleName, 
     transctionalRoleID:roleSelected.transctionalRoleID,
     contactID:Number(sessionStorage.getItem("transactionID")),
     associatedContactID:Number(this.currentRoleContact.associatedContactID),
     //userID :Number(this.currentRoleContact.userID),
   });
  } 

  if(this.Roles.length > 0){
    this.showContactRoleAddButton=true;
  }
  if(this.Roles.length == 0){
    this.showContactRoleAddButton=false;
  }
}

RoleSelectedForCompany(roleSelected:any){
  let role= this.RolesCompany.find(m=>m.transctionalRoleID == roleSelected.transctionalRoleID);  
  if(roleSelected.transctionalRoleID == 0) { 
  if(this.currentRoleCompany.companyCoreRoleMappingModels.find(m=>m.rloeName.toLowerCase()==roleSelected.transactionalRoleName.toLowerCase())!=undefined) {
    this.toastr.warning('Role already selected.', '', {
      timeOut: 1000,
    });
    return;
  }
   let newRole = this.RolesCompany.find(m=>m.transactionalRoleName.toLowerCase() == roleSelected.transactionalRoleName.toLowerCase());
   if(newRole == undefined) { 
     this.RolesCompany.push({
        transactionalRoleName : roleSelected.transactionalRoleName, 
        transctionalRoleID: roleSelected.transctionalRoleID,
        ContactID: Number(sessionStorage.getItem("transactionID")),
        CompanyID: Number(this.currentRoleCompany.companyID)
      });
      if(this.RolesCompany.length > 0){
        this.showCompanyRoleAddButton=true;
      }
      if(this.RolesCompany.length == 0){
        this.showCompanyRoleAddButton=false;
      }
    }
    return;
  }
  
  if(role == undefined || role == '' || role == null) { 
    this.RolesCompany.push({
     transactionalRoleName : roleSelected.transactionalRoleName, 
     transctionalRoleID: roleSelected.transctionalRoleID,
     ContactID: Number(sessionStorage.getItem("transactionID")),
     CompanyID: Number(this.currentRoleCompany.companyID)
   });
  } 

  if(this.RolesCompany.length > 0){
    this.showCompanyRoleAddButton=true;
  }
  if(this.RolesCompany.length == 0){
    this.showCompanyRoleAddButton=false;
  }
}

removeItemRoleCompany(item:any,isRolePopup:boolean){
  if(this.isRolePopup){
    const index = this.RolesCompany.indexOf(item);
    if (index >= 0) {
          this.RolesCompany.splice(index, 1);
        } 
       if(this.RolesCompany.length > 0){
        this.showCompanyRoleAddButton =true;
        }
        if(this.RolesCompany.length == 0){
          this.showCompanyRoleAddButton =false;
        }
  }  
}

addUpdateContactContactRole(){
  if(this.Roles.length > 0) {
    this.ContactRoleUpdate()
 } 
}

addUpdateContactCompanyRole(){  
 if(this.RolesCompany.length > 0) {
  this.CompanyRoleUpdate()
}  
}


ContactRoleUpdate(){
  if(this.Roles.length>0) { 
    this.dialog.closeAll();
    this.contactsVm.DatabaseID = Number(this.databaseId);
    this.contactsVm.OrganizationID = Number(this.organizationId);
    this.contactsVm.UserID = this.currentUser.UID;
    this.contactsVm.IsAdded = true;
    this.contactsVm.OfficeID = this.myOfficeID;
    this.contactsVm.associatedContactID = Number(this.currentRoleContact.associatedContactID);
    this.contactsVm.ContactContactRoleModels = this.Roles;
    this.contactsVm.sharedUserID = Number(this.currentRoleContact.userID);
    this.loaderService.show();
    this.contactsService.addUpdateContactContactRole(this.contactsVm).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.NormalContacts = response.data.contactListModel;
          this.SharedContacts= response.data.sharedContactListModel;
          this.NormalContacts.forEach(e => {
            e.shortName=e.name.match(/\b(\w)/g).join('');
          });
          if(this.SharedContacts!=null){
            this.SharedContacts.forEach(e => {
              if(e.userID>0){
                e.name= this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.name) +' '+this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.lastName);
                e.email= this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.email);
                e.shortName=e.name.match(/\b(\w)/g).join('');
              }else{
                e.shortName=e.name.match(/\b(\w)/g).join('');
              }
              if(e.contactContactRoleMappingModel==null){
                e.contactContactRoleMappingModel=[];
              }       
            });
          } 
          this.NormalContacts.forEach(e => {
            e.shortName=e.name.match(/\b(\w)/g).join('');
          });
          this.Roles=[];
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
 } else {
  this.dialog.closeAll();
 }
}

CompanyRoleUpdate(){
  if(this.RolesCompany.length > 0) { 
    this.dialog.closeAll();
    this.companysVm.DatabaseID = Number(this.databaseId);
    this.companysVm.OrganizationID = Number(this.organizationId);
    this.companysVm.UserID = this.currentUser.UID;
    this.companysVm.IsAdded = true;
    this.companysVm.CoreContactCompanyRoleModels = this.RolesCompany;
    this.companysVm.OfficeID = this.myOfficeID;
    this.loaderService.show();
    this.contactsService.addUpdateContactCompanyRole(this.companysVm).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.NormalCompanys = response.data.companyListModel;        
          this.NormalCompanys.forEach(e => {
            e.shortName=e.name.match(/\b(\w)/g).join('');
          });         
          this.RolesCompany=[];
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
 } else {
  this.dialog.closeAll();
 }
}

addUpdateContactContact(){
  if(this.isSharedAccessRolePopup == false && this.isSharedAccessUserPopup==false){
    if(this.peoples.length > 0) { 
      this.dialog.closeAll();
      this.contactsVm.DatabaseID = Number(this.databaseId);
      this.contactsVm.OrganizationID = Number(this.organizationId);
      this.contactsVm.UserID = this.currentUser.UID;
      this.contactsVm.AddUpdateContactContactListModel=this.peoples;
      this.contactsVm.OfficeID=this.myOfficeID;
      this.loaderService.show();
      this.contactsService.addUpdateContactContact(this.contactsVm).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.NormalContacts = response.data.contactListModel;
            this.SharedContacts= response.data.sharedContactListModel;
            this.NormalContacts.forEach(e => {
              e.shortName=e.name.match(/\b(\w)/g).join('');
            });
            if(this.SharedContacts!=null){
              this.SharedContacts.forEach(e => {
                if(e.userID>0){
                  e.name= this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.name) +' '+this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.lastName);
                  e.email= this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.email);
                  e.shortName=e.name.match(/\b(\w)/g).join('');
                }else{
                  e.shortName=e.name.match(/\b(\w)/g).join('');
                }
                if(e.contactContactRoleMappingModel==null){
                  e.contactContactRoleMappingModel=[];
                }       
              });
            } 
            
            this.peoples=[];
            this.selectedcompanyList=[];
            this.showAddButton=false;
            this.loaderService.hide();
          }
          else{
            this.loaderService.hide();
          }
        }      
      });
   }
   else{
     this.loaderService.hide();
    this.dialog.closeAll();
   }
  }
 
  if(this.isSharedAccessRolePopup == true && this.isSharedAccessUserPopup==false){
    if(this.selectedsharedAccessRole.length > 0) { 
      this.dialog.closeAll();
      this.contactsVm.DatabaseID = Number(this.databaseId);
      this.contactsVm.OrganizationID = Number(this.organizationId);
      this.contactsVm.UserID = this.currentUser.UID;
      this.contactsVm.OfficeID=this.myOfficeID;
      this.contactsVm.AddUpdateContactContactListModel = this.selectedsharedAccessRole;
      this.loaderService.show();
      this.contactsService.addUpdateContactContact(this.contactsVm).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.Owners=response.data.owners;
            this.NormalContacts = response.data.contactListModel;
            this.SharedContacts= response.data.sharedContactListModel;
            this.SharedRoleList = response.data.sharedRoleListModel;
            if(this.Owners!=null){
            this.Owners.forEach(e => {
              e.name= this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.name) +' '+this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.lastName);
              e.email= this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.email);
              e.shortName=e.name.match(/\b(\w)/g).join('');
            });
           }
            this.NormalContacts.forEach(e => {
              e.shortName=e.name.match(/\b(\w)/g).join('');
            });
            if(this.SharedContacts!=null){
              this.SharedContacts.forEach(e => {
                if(e.userID>0){
                  e.name= this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.name) +' '+this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.lastName);
                  e.email= this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.email);
                  e.shortName=e.name.match(/\b(\w)/g).join('');
                }else{
                  e.shortName=e.name.match(/\b(\w)/g).join('');
                }
                if(e.contactContactRoleMappingModel==null){
                  e.contactContactRoleMappingModel=[];
                }       
              });
            } 
            this.SharedRoleList.forEach(e => {
              e.shortName=e.name.match(/\b(\w)/g).join('');
            });
            if(this.Owners==null){
              this.Owners=[];
            }
            this.peoples=[];
            this.selectedcompanyList=[];
            this.selectedsharedAccessRole=[];  
            this.showAddButton=false;
            this.loaderService.hide();
          }
          else{
            this.loaderService.hide();
          }
        }      
      });
   }
   else{
     this.loaderService.hide();
    this.dialog.closeAll();
   }
  }

  if(this.isSharedAccessUserPopup==true){
    if(this.userSelectedList.length > 0) { 
      this.dialog.closeAll();
      this.contactsVm.DatabaseID = Number(this.databaseId);
      this.contactsVm.OrganizationID = Number(this.organizationId);
      this.contactsVm.UserID = this.currentUser.UID;
      this.contactsVm.AddUpdateContactContactListModel=this.userSelectedList;
      this.contactsVm.OfficeID=this.myOfficeID;
      this.loaderService.show();
      this.contactsService.addUpdateContactContact(this.contactsVm).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.NormalContacts = response.data.contactListModel;
            this.SharedContacts= response.data.sharedContactListModel;
            this.Owners=response.data.owners;
            this.NormalContacts.forEach(e => {
              e.shortName=e.name.match(/\b(\w)/g).join('');
            });
            if(this.SharedContacts!=null){
              this.SharedContacts.forEach(e => {
                if(e.userID>0){
                  e.name= this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.name) +' '+this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.lastName);
                  e.email= this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.email);
                  e.shortName=e.name.match(/\b(\w)/g).join('');
                }else{
                  e.shortName=e.name.match(/\b(\w)/g).join('');
                }
                if(e.contactContactRoleMappingModel==null){
                  e.contactContactRoleMappingModel=[];
                }       
              });
            } 
            if(this.Owners!=null){
              this.Owners.forEach(e => {
                e.name= this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.name) +' '+this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.lastName);
                e.email= this.encryptionAlgo.get(this.reusableClass.decryptionKey,e.email);
                e.shortName=e.name.match(/\b(\w)/g).join('');
              });
             }
             if(this.Owners==null){
              this.Owners=[];
             }
            this.peoples=[];
            this.selectedcompanyList=[];
            this.showAddButton=false;
            this.loaderService.hide();
          }
          else{
            this.loaderService.hide();
          }
        }      
      });
   }
   else{
     this.loaderService.hide();
    this.dialog.closeAll();
   }
  }
}

addUpdateContactCompany(){
  if(this.selectedcompanyList.length>0) { 
    this.dialog.closeAll();
    this.companysVm.DatabaseID = Number(this.databaseId);
    this.companysVm.OrganizationID = Number(this.organizationId);
    this.companysVm.UserID = this.currentUser.UID;
    this.companysVm.AddUpdateCoreContactCompanyListModel=this.selectedcompanyList;
    this.contactsVm.OfficeID=this.myOfficeID;
    this.loaderService.show();
    this.contactsService.addUpdateContactCompany(this.companysVm).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.NormalCompanys = response.data.companyListModel;     
          if(this.NormalCompanys!=null){
            this.NormalCompanys.forEach(e => {
              e.shortName=e.name.match(/\b(\w)/g).join('');
            });
          }      
          this.selectedcompanyList=[];
          this.showAddButton=false;
          this.loaderService.hide();
        }
      }
    });
 }
 else {
  this.dialog.closeAll();
 }
}

removeItem(item:any,isRolePopup:boolean){
  if(this.isRolePopup) {
    //this.Roles.pop(item);
    const index = this.Roles.indexOf(item);
  if (index >= 0) {
    this.Roles.splice(index, 1);
  }
 }
  
  else{
    const index = this.peoples.indexOf(item);
  if (index >= 0) {
    this.peoples.splice(index, 1);
  }
    //this.peoples.pop(item);
  }
 
  if(this.peoples.length == 0){
    this.showAddButton =false;
  }
  if(this.Roles.length > 0){
    this.showContactRoleAddButton=true;
  }
  if(this.Roles.length == 0){
    this.showContactRoleAddButton=false;
  }
}

removeItemCompany(item:any,isRolePopup:boolean){
  if(this.isRolePopup){
    const index = this.RolesCompany.indexOf(item);
  if (index >= 0) {
    this.RolesCompany.splice(index, 1);
  }
}  
  else{
  const index = this.selectedcompanyList.indexOf(item);
  if (index >= 0) {
    this.selectedcompanyList.splice(index, 1);
  }
  if(this.selectedcompanyList.length == 0){
    this.showAddButton =false;
  }
 }  
}



addShare(templateRef: TemplateRef<any>,isShare:boolean,isRole:boolean,contact:any) {
  this.isShare=isShare;
  this.isRolePopup=isRole;
  this.isSharedAccessRolePopup=false;
  this.contactID=Number(sessionStorage.getItem("transactionID"));
  if(isRole)
  this.currentRoleContact=contact;
  this.transRoleList=[];
  this.contactsList=[];
  this.companysList=[];
  this.Roles=[];
  this.peoples=[];
  this.selectedsharedAccessRole=[];
  this.selectedcompanyList=[];
  this.showContactRoleAddButton=false;
  this.isSharedAccessUserPopup=false;
  this.userSelectedList=[];
  this.isAddOwner=false;
  this.showAddButton=false; 
  const dialogRef = this.dialog.open(templateRef,{
    panelClass: 'custom-modalbox'
  });
}

addOwner(templateRef: TemplateRef<any>,isShare:boolean,isRole:boolean,contact:any) {
  this.isShare=isShare;
  this.isRolePopup=isRole;
  this.isSharedAccessRolePopup=false;
  this.contactID=Number(sessionStorage.getItem("transactionID"));
  if(isRole)
  this.currentRoleContact=contact;
  this.transRoleList=[];
  this.contactsList=[];
  this.companysList=[];
  this.Roles=[];
  this.peoples=[];
  this.selectedsharedAccessRole=[];
  this.selectedcompanyList=[];
  this.showContactRoleAddButton=false;
  this.isSharedAccessUserPopup=true;
  this.userSelectedList=[];
  this.isAddOwner=true;
  this.showAddButton=false; 
  this.isRolePopup=false;
  const dialogRef = this.dialog.open(templateRef,{
    panelClass: 'custom-modalbox'
  });
}

addShareCompany(templateRef: TemplateRef<any>,isShare:boolean,isRole:boolean,company:any) {
  this.isShare=isShare;
  this.isRolePopup=isRole;
  this.contactID=Number(sessionStorage.getItem("transactionID"));
  if(isRole)
  this.currentRoleContact=company;
  this.currentRoleCompany = this.currentRoleContact;
  this.transRoleList=[];
  this.contactsList=[];
  this.companysList=[];
  this.Roles=[];
  this.peoples=[];
  this.selectedcompanyList=[];
  this.showCompanyRoleAddButton=false;
  const dialogRef = this.dialog.open(templateRef,{
    panelClass: 'custom-modalbox'
  });
}

close() {
  this.peoples=[];
  this.selectedcompanyList=[];
  this.Roles=[];
  this.RolesCompany=[];
  this.showAddButton=false;
  this.sharedAccessUserList=[];
  this.isSharedAccessUserPopup=false;
  this.userSelectedList=[];
  this.dialog.closeAll();
}

deleteRole(contactContactRoleID:any,e:any ){
  const message = `Are you sure you want to delete this relation?`;
  const title = `Confirm Delete`;
  const confirm = `Delete`;
  const dialogData = new ConfirmDialogModel(title, message,confirm);
  const dialogRef = this.dialog.open(ConfirmDialogComponent, {
    panelClass: 'edituserdetails',
    maxWidth: '1000px',
    maxHeight: '500px',
    data: dialogData,
  });
  dialogRef.beforeClosed().subscribe(async (dialogResult) => {
    if(dialogResult){
      e.target.parentElement.remove();
      this.contactsVm.DatabaseID = Number(this.databaseId);
      this.contactsVm.OrganizationID = Number(this.organizationId);
      this.contactsVm.UserID = this.currentUser.UID;
      this.contactsVm.ContactContactRoleID=Number(contactContactRoleID);
      this.loaderService.show();
      this.contactsService.deleteSelectedContactContact(this.contactsVm).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.toastr.success('Relation deleted successfully.', '', {
              timeOut: 1000,
            });
            this.loaderService.hide();
          }
        }
      });
    }
  });
}

deleteCompanyRole(companyCoreRoleID:any,e:any ){
  const message = `Are you sure you want to delete this relation?`;
  const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
  const dialogRef = this.dialog.open(ConfirmDialogComponent, {
    panelClass: 'edituserdetails',
    maxWidth: '1000px',
    maxHeight: '500px',
    data: dialogData,
  });
  dialogRef.beforeClosed().subscribe(async (dialogResult) => {
    if(dialogResult){
      e.target.parentElement.remove();
      this.companysVm.DatabaseID = Number(this.databaseId);
      this.companysVm.OrganizationID = Number(this.organizationId);
      this.companysVm.UserID = this.currentUser.UID;
      this.companysVm.contactCompanyRoleID=Number(companyCoreRoleID);
      this.loaderService.show();
      this.contactsService.deleteSelectedRoleContactCompany(this.companysVm).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.toastr.success('Relation deleted successfully.', '', {
              timeOut: 1000,
            });
            this.loaderService.hide();
          }
        }
      });
    }
  });
}



//== For Shared Access Role == //

getSharedAccessRoles(searchValue:any) {  
  var ReqModel={
    searchKey: "",
    pageIndex: 0,
    pageSize: 0,
    databaseID:  Number(this.databaseId),
    organizationID: Number(this.organizationId),
    searchValue: searchValue
  }
  this.contactsService.getSharedAccessRoles(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.sharedAccessRoleList = response.data;
        this.SharedRoleList;
        if(this.SharedRoleList.length > 0){
          this.sharedAccessRoleList = this.sharedAccessRoleList.filter(({ roleID: id1 }) => !this.SharedRoleList.some(({ roleID: id2 }) => id2 === id1));
        }     
      }
    }
  });
}

RoleSelectedForSharedAccess(roleSelected:any){
  let role= this.selectedsharedAccessRole.find(m=>m.roleID == roleSelected.roleID);  
  if(roleSelected.roleID == 0) { 
  // if(this.currentRoleCompany.companyCoreRoleMappingModels.find(m=>m.rloeName.toLowerCase()==roleSelected.name.toLowerCase())!=undefined)
  // {
  //   this.toastr.warning('Role already selected.', '', {
  //     timeOut: 1000,
  //   });
  //   return;
  // }
   let newRole = this.selectedsharedAccessRole.find(m=>m.name.toLowerCase() == roleSelected.name.toLowerCase());
   if(newRole == undefined) { 
     this.selectedsharedAccessRole.push({       
        name : roleSelected.roleName,
        email: '',
        img: '', 
        associatedContactID:0,
        roleID:roleSelected.roleID,
        isShared:this.isShare,
        shortName:'',
        ContactID:Number(sessionStorage.getItem("transactionID")), 
      });
      if(this.selectedsharedAccessRole.length > 0){
        this.showAddButton=true;
      }
      if(this.selectedsharedAccessRole.length == 0){
        this.showAddButton=false;
      }
    }
    return;
  }
  
  if(role == undefined || role == '' || role == null) { 
    this.selectedsharedAccessRole.push({
      name : roleSelected.roleName,
      email: '',
      img: '', 
      associatedContactID:0,
      roleID:roleSelected.roleID,
      isShared:this.isShare,
      shortName:'',
      ContactID:Number(sessionStorage.getItem("transactionID")), 
   });
  } 

  if(this.selectedsharedAccessRole.length > 0){
    this.showAddButton=true;
  }
  if(this.selectedsharedAccessRole.length == 0){
    this.showAddButton=false;
  }
}

removeItemRoleSharedAccess(item:any,isSharedAccessRolePopup:boolean){
  if(this.isSharedAccessRolePopup){
    const index = this.selectedsharedAccessRole.indexOf(item);
    if (index >= 0) {
          this.selectedsharedAccessRole.splice(index, 1);
        }      
       if(this.selectedsharedAccessRole.length > 0){
        this.showAddButton =true;
      }
        if(this.selectedsharedAccessRole.length == 0){
          this.showAddButton =false;
        }
  }  
}


selectSharedAccessRb(value){
if(value == 2){
  this.isSharedAccessRolePopup=true;
  this.peoples=[];
  this.selectedsharedAccessRole=[];
  this.showAddButton =false;
  this.isSharedAccessUserPopup=false;
  this.userSelectedList=[];
}
if(value == 1){
  this.isSharedAccessRolePopup=false;
  this.peoples=[];
  this.selectedsharedAccessRole=[];
  this.showAddButton =false;
  this.isSharedAccessUserPopup=false;
  this.userSelectedList=[];
}
if(value == 3){
  this.isSharedAccessRolePopup=false;
  this.isSharedAccessUserPopup=true;
  this.peoples=[];
  this.selectedsharedAccessRole=[];
  this.userSelectedList=[];
  this.showAddButton =false;
}
}


selectedUser: any = [] = [];
userSelectedList: any = [];
timeout = null;
isSharedAccessUserPopup:boolean=false;
sharedAccessUserList: any=[];
isAddOwner:boolean=false;

searchUser(val) {
  if (val.length >= 2) {
    this.sharedAccessUserList = [];
    if (val != '') {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.getUserListCoreImplementation(val)
      }, 500);
    } else {
      this.sharedAccessUserList = [];
    }
  }
}

getUserListCoreImplementation(searchValue: any) {
  if (searchValue == "" || searchValue == null || searchValue == undefined) {
    this.sharedAccessUserList = [];
    return;
  }
  var ReqModel = {
    DatabaseID: Number(this.databaseId),
    OrganizationID: Number(this.organizationId),
    officeID:this.myOfficeID,
    searchKey: searchValue.trim(),
    PageSize: 0,
    pageIndex: 0,
    UserID: this.currentUser.UID
  }
  this.contactsService.GetUserList(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.sharedAccessUserList = response.data.userModel;
        this.sharedAccessUserList.map((res) => {
          if (res.email != null) {
            res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
          }
          if (res.firstName != null) {
            res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
          }
          if (res.lastName != null) {
            res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
          }
          return res;
        });
        this.sharedAccessUserList = this.sharedAccessUserList;
      }
    }
  });
}

userSelected(userSelected: any) {
  this.stateCtrl.setValue('');
  var user=[];
  user = this.userSelectedList.filter(m => m.userID == userSelected.userID);
  if (user.length==0) {
    var isOwner=false;
    if(this.isAddOwner==true){
      isOwner=true;
    }else{
      isOwner=false;
    }
    if(this.isAddOwner==false){
      var users=[];
      users = this.SharedContacts.filter(m => m.userID == userSelected.userID);
      if(users.length>0){
        this.toastr.warning('User allready added in shared access list.', '', {
          timeOut: 3000,
        });
        if(this.userSelectedList.length > 0){
          this.showAddButton=true;
        }
        else{
          this.showAddButton=false;
        } 
        return;
      }     
    }
    var shortName = userSelected.firstName.match(/\b(\w)/g).join('');

    this.userSelectedList.push({
       name: userSelected.firstName + " " + userSelected.lastName,      
       email: userSelected.email,
       associatedContactID: 0,
       roleID:  0,
       userID: userSelected.userID,      
       img: "",
       shortName:shortName,
       isShared:true,
       isOwner:isOwner,
       ContactID:Number(sessionStorage.getItem("transactionID")), 
    });   
    
  }else{
    this.toastr.warning('User allready added.', '', {
      timeOut: 3000,
    });
  }
  if(this.userSelectedList.length > 0){
    this.showAddButton=true;
  }
  else{
    this.showAddButton=false;
  } 
}

removeUser(item: any) {
  const index = this.userSelectedList.indexOf(item);
  if (index >= 0) {
    this.userSelectedList.splice(index, 1);   
  }
  if(this.userSelectedList.length == 0){
    this.showAddButton =false;
  }
}

states: State[] = [
  {
    name: 'Abbott',
    email: 'Abbott@gmail.com',
    role: 'agent',
    pic: '../../../../../assets/images/avatars/Abbott.jpg'
  },
  {
    name: 'Alice',
    email: 'alice.@gmail.com',
    role: 'agent',
    pic: '../../../../../assets/images/avatars/alice.jpg'
  },
  {
    name: 'Carl',
    email: 'carl@gmail.com',
    role: 'agent',
    pic: '../../../../../assets/images/avatars/carl.jpg'
  },
  {
    name: 'Jane',
    email: 'jane@gmail.com',
    role: 'agent',
    pic: '../../../../../assets/images/avatars/jane.jpg'
  },
  {
    name: 'Tillman',
    email: 'tillman.@gmail.com',
    role: 'agent',
    pic: '../../../../../assets/images/avatars/Tillman.jpg'
  },
  {
    name: 'Josefina',
    email: 'Josefina@gmail.com',
    role: 'agent',
    pic: '../../../../../assets/images/avatars/Josefina.jpg'
  },
  {
    name: 'Create New',
    email: ' ',
    role: ' ',
    pic: ' '
  },

];

}
